import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

export default {
  async getByWorkOrderId({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'GetByWorkOrderId', () =>
      http.get(`ClientSurvey/GetByWorkOrderId?workOrderId=${data.workOrderId}`)
    )

    commit(types.SET_SURVEY_DATA, r.data)
    return r.data
  },
  async upsert({ commit, dispatch }, data) {
    const res = await startLoading(dispatch, 'UpsertClientSurvey', () =>
      http.post('ClientSurvey/UpsertClientSurvey', data)
    )
    return res.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/clientsurvey/actions.js